import React from 'react';
import $ from 'jquery';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';

class Signup extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      name: "",
      number: "",
      email: props.userMail,
      id: "Voter's ID",
      id_num: "",
      address: "",
      base: "37 miltary hospital",
      sent: false,
      finished: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    if (!this.state.email) {
      this.setState({
        email: this.props.userMail
      })
    }

    let { id, value } = event.target;
    this.setState({ [id]: value });
  }

  handleSubmit() {
    //check necessary inputs
    //checking

    if (this.state.name == undefined || this.state.name == "") {
      document.getElementById("info").innerHTML = "Enter your name";
      setTimeout(() => { document.getElementById("name").scrollIntoView({ behavior: "smooth", block: "center" }) }, 2000);
      return;
    }

    if (this.state.number == undefined || this.state.number == "" || this.state.number.length < 10) {
      document.getElementById("info").innerHTML = "Enter your number";
      setTimeout(() => { document.getElementById("number").scrollIntoView({ behavior: "smooth", block: "center" }) }, 2000);
      return;
    }

    let email = this.state.email;
    let filter = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/;

    if (!filter.test(email)) {
      document.getElementById("info").innerHTML = "Enter your email";
      setTimeout(() => { document.getElementById("email").scrollIntoView({ behavior: "smooth", block: "center" }) }, 2000);
      return;
    }

    if (this.state.id_num == undefined || this.state.id_num == "") {
      document.getElementById("info").innerHTML = "Enter your ID number";
      setTimeout(() => { document.getElementById("id_num").scrollIntoView({ behavior: "smooth", block: "center" }) }, 2000);
      return;
    }

    if (this.state.address == undefined || this.state.address == "") {
      document.getElementById("info").innerHTML = "Enter your address";
      setTimeout(() => { document.getElementById("address").scrollIntoView({ behavior: "smooth", block: "center" }) }, 2000);
      return;
    }

    //submit to api
    if (this.state.sent) return;
    this.setState({ sent: true });
    document.getElementById("send").innerHTML = "sending...";

    let data = {
      name: this.state.name,
      number: this.state.number,
      email: this.state.email,
      id: this.state.id,
      id_num: this.state.id_num,
      address: this.state.address,
      location: this.state.base,
    };

    let settings = {
      "async": true,
      "crossDomain": true,
      "url": `https://deliveryapi-3765.herokuapp.com/api/riders/signup`,
      "method": "POST",
      "headers": {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      "data": data
    }

    $.ajax(settings).done(function (response, textStatus, xhr) {
      //done
      $("#sent-modal").css({ "display": "block" });
      document.getElementById("send").innerHTML = "Done";
      this.setState({ finished: true });
    }.bind(this))
      .fail(function (xhr, textStatus) {
        if (xhr.status == 409) return document.getElementById("send").innerHTML = "Already exists";
        document.getElementById("send").innerHTML = "Error";
      });
  }

  componentDidMount() {

    document.getElementById("start").scrollIntoView({ behavior: "smooth", block: "center" });

    let settings = {
      "async": true,
      "crossDomain": true,
      "url": `https://deliveryapi-3765.herokuapp.com/api`,
      "method": "GET",
      "headers": {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    }

    $.ajax(settings).done(function (response) {
      //done

    });
  }

  render() {
    return (
      <section>
        <div className="header-05 container container--large header-07__container">
          <div className="header-07__left">
            <div className="header-07__left_content">
              <h1 className="heading heading--accent header-07__heading">Become an Agent Today.</h1>
              <p className="header-07__text">Provide the necessary details and we'll contact you within 24 hours.</p>
              <div className="header-07__buttons_box header-07__cta_box">
                <div className="buttons-set">
                  <ul className="buttons-set__list">
                    <li className="buttons-set__item"><Link to="/" className="button   button--accent-bg "
                    >Home</Link>
                    </li>
                    <li className="buttons-set__item">
                      <Link to="/main" className="button button--accent-outline state-active" type="button">Get Riders </Link>
                    </li>
                  </ul>
                  <div className="score">
                    <div className="score__stars"><img className="score__star" src="img/icons/star--blue.svg" /><img
                      className="score__star" src="img/icons/star--blue.svg" /><img className="score__star"
                        src="img/icons/star--blue.svg" /><img className="score__star" src="img/icons/star--blue.svg" /><img
                        className="score__star" src="img/icons/star--1-4--blue.svg" /></div>
                    <div className="score__text"><span className="score__word">Based on 15+ <br /><a
                      href="https://www.producthunt.com" target="_blank">Product Hunt </a><br />
                      reviews.</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="header-07__right">
            <div className="header-07__img_box"><img className="header-07__img" src="img/other/model.jpg" alt="model" /></div>
          </div>
        </div>

        {!this.state.finished ? (
          <div className="cta_button-01">
            <div className="container container--mid">
              <div className="title-box title-box--center">
                <div className="subheading white-text">Join Parcels Today</div>
                <h2 className="heading white-text">Kindly fill the form</h2>
                <p className="title-box__text white-text" id="start">Provide information that is true to the best of your knowledge.</p>
              </div>
            </div>

            <div className="delivery-input">
              <input id="name" className="text-input js-name-input" type="name" name="name" placeholder="Enter your Full Name"
                onChange={this.handleChange} value={this.state.name} />

              <input id="number" maxLength="10" className="text-input js-number-input" type="number" name="number" placeholder="Enter your phone Number"
                onChange={this.handleChange} value={this.state.number} />

              <input id="email" className="text-input js-email-input" type="email" name="EMAIL" placeholder="Enter your Email"
                onChange={this.handleChange} value={this.state.email} disabled />

              <p>Identification details</p>
              <select id="id" className="text-input" style={{
                width: 260, height: 40,
                padding: 10, borderRadius: 15
              }} onChange={this.handleChange} value={this.state.id}>
                <option id="id">Voter's ID</option>
                <option id="id">Passport</option>
                <option id="id">Drivers License</option>
              </select>

              <input className="text-input" type="text" id="id_num" name="id_num" placeholder="ID Number"
                required onChange={this.handleChange} value={this.state.id_num} />

              <br /><hr /><br />

              <input className="text-input" type="text" id="address" name="address"
                placeholder="House/Digital Address" required onChange={this.handleChange} value={this.state.address} />

              <p>Select location you are usually around</p>
              <select className="text-input" id="destination" style={{ width: 260, padding: 10, borderRadius: 15 }}
                onChange={this.handleChange} value={this.state.destination}>
                <option value='37 miltary hospital'> 37 miltary hospital</option>
                <option value="Accra Central">Accra Central </option>
                <option value='Adenta'>Adenta</option>
                <option value='Achimota'>Achimota</option>
                <option value='Ablekuma'>Ablekuma</option>
                <option value='Circle'>Circle</option>
                <option value='Cantoments'>Cantoments</option>
                <option value='Dome'>Dome</option>
                <option value='Eastlegon'>East Legon</option>
                <option value='Haatso'>Haatso</option>
                <option value='Legon Campus'>Legon Campus</option>
                <option value='Labadi'>Labadi</option>
                <option value='Madina'>Madina</option>
                <option value='Nima'>Nima</option>
                <option value='Osu'>Osu</option>
                <option value='Spintex'>Spintex</option>
                <option value='Shiashie'>Shiashie</option>
                <option value='Tema'>Tema</option>
                <option value='UPSA Campus'>UPSA Campus</option>
              </select>

              <p>The information provided above will be reviewed and verified by our team. Details such as
              your address shall be updated if necessary. <span style={{ textDecoration: "underline" }}>
                  Do you confirm that the information given above is true to the best of your knowledge and have accepted our
              <Link to="Terms"><span style={{ color: "cream", fontWeight: "bold" }} target="__blank"> Terms and Conditions</span></Link>?</span></p>

            </div>

            <div className="container container--small">
              <div className="cta_button-01__button_box">
                <div className="cta_button-01__button_wrapper">
                  <div className="cta_button-01__tag"><span className="tag   tag--night"><span className="tag__text">Join the team</span></span>
                  </div><button onClick={this.handleSubmit} id="send" className="button button--large  button--alt-accent-bg "><span>I confirm</span></button>

                  <p id="info" style={{ color: "white", fontWeight: "bold" }}></p>
                  <p id="info2"></p>
                </div>
              </div>
            </div>
          </div>
        ) : (
            <div className="cta_button-01">
              <div className="container container--mid">
                <div className="title-box title-box--center">
                  <div className="subheading white-text">Parcels Today</div>
                  <h2 className="heading white-text">We appreciate your interest</h2>
                  <p className="title-box__text white-text" id="start">Our team will review your details and give you a call within 48 hours.</p>
                </div>
              </div>
            </div>
          )}

      </section>
    )
  }
}

export default Signup;